<div class="form-check fn-control-label">
  <input class="form-check-input" type="checkbox" [name]="name" [id]="id"  [(ngModel)]="value" [disabled]="isDisabled">
  <label class="form-check-label" [for]="id">@if (label!=undefined) {
    <span [class]="labelClass">{{label | fnTranslate}}</span>
  }</label>
</div>
